export default __webpack_public_path__ + "static/media/CSIO_2021_Annual_Report_National_Standards_working_group.a7f3cd7a.pdf";